<script>
import ListBase from '@/components/ListBase';

export default {
  name: "ListaUsuarios",
  extends: ListBase,
  data: () => ({
    baseApi: "usuarios",
    headers: [
      { text: 'Nombre de Usuario', value: 'username' },
      { text: 'Rol', value: 'rol', format: v => v.nombre },
    ],
  }),
  computed: {
    canCreate() {
      return true;
    },
  },
}
</script>

<style scoped>

</style>
